export class AnimationStates {
    public static State = { WAITING: 1, EXITED: 0 };
}
